// Angular
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { TonKhoHienTai } from '../ton-kho-hien-tai-model/ton-kho-hien-tai.model';

@Component({
  	selector: 'kt-ton-kho-hien-tai-popup',
  	templateUrl: './ton-kho-hien-tai-popup.component.html'
})
export class TonKhoHienTaiPopUpComponent implements OnInit {
	// Các thuộc tính công khai
	isLoading: boolean = false;
	filteredTags: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	selectedTags: string[] = [];
	selectedNoteQA: string = "";
	isPopupTag: boolean = false;
	isPopupNoteQA: boolean = false;
	popup = TonKhoHienTai.POPUP_MULTIPLE;
	info = {};

	constructor(
		public dialogRef: MatDialogRef<TonKhoHienTaiPopUpComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private changeDetectorRef: ChangeDetectorRef
	) {
		this.isPopupTag = this.popup[TonKhoHienTai.INDEX_TAG].Code == this.data.popupCode;
		this.isPopupNoteQA = this.popup[TonKhoHienTai.INDEX_NOTE_QA].Code == this.data.popupCode;
		this.info = this.popup.find(p => p.Code == this.data.popupCode);
	}

	ngOnInit(): void {
		// Khởi tạo danh sách các thẻ đã lọc
		this.filteredTags.next(this.data.tags.slice());
	}

	// Đóng hộp thoại mà không có kết quả
	onCancel(): void {
		this.dialogRef.close();
	}

	// Đóng hộp thoại với kết quả là true
	onConfirm(): void {
		this.isLoading = true;
		let data = this.isPopupTag ? this.selectedTags : (this.isPopupNoteQA ? this.selectedNoteQA : null);
		setTimeout(() => {
			this.dialogRef.close({ data: data });
		}, 0);
	}

	// Lọc thẻ dựa trên đầu vào tìm kiếm
	onSearch(event): void {
		const input = event.target;
		const searchTerm = input.value.toLowerCase();
		const filteredTags = searchTerm
			? this.data.tags.filter(tag => tag.toLowerCase().includes(searchTerm))
			: this.data.tags.slice();
		this.filteredTags.next(filteredTags);
		this.changeDetectorRef.markForCheck();
	}

	// Xử lý việc chọn thẻ từ autocomplete
	onTagSelect(event: MatAutocompleteSelectedEvent): void {
		const selectedTag = event.option.viewValue;
		if (!this.selectedTags.includes(selectedTag)) {
			this.selectedTags.push(selectedTag);
			this.changeDetectorRef.markForCheck();
		}
	}

	// Xóa một thẻ khỏi danh sách các thẻ đã chọn
	onTagRemove(tag: string): void {
		this.selectedTags = this.selectedTags.filter(selectedTag => selectedTag !== tag);
		this.changeDetectorRef.markForCheck();
	}

	// Lấy màu nền của thẻ
	getTagBackgroundColor(tag: string): string {
		const tagInfo = this.data.infoTags.find(infoTag => infoTag.tagkho === tag);
		return tagInfo ? tagInfo.BackgroundColor : 'red';
	}

	onTrim(str: string) {
		return str.trim();
	}
}
